module.exports = __webpack_public_path__ + "img/9.6fcf1947.png";